import styled from 'styled-components';
import * as variables from 'pubweb-smokey/dist/components/GridSystem/_vars_widths';
import Colors from 'pubweb-smokey/dist/colors';

export const HomeCardDetailedStyles = styled.div`
  background-color: ${Colors.primary.white.standard};
  border: 0;
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);

  .home-image {
    .home-image-container {
      align-items: center;
      background-color: ${Colors.accent.grey4.standard};
      border-radius: 4px;
      display: flex;
      height: 225px;
      justify-content: center;
      position: relative;
      margin-bottom: 5px;
      overflow: hidden;
      width: 100%;
      a.home-card-link {
        height: 100%;
        width: 100%;
      }
    }
    img {
      height: auto;
      min-height: 100%;
      max-width: 100%;
      object-fit: cover;
      width: auto;
    }
    .favoriting-heart-container {
      position: absolute;
      right: 10px;
      top: 10px;
    }

    .home-virtual-tour:link,
    .home-virtual-tour:visited,
    .home-virtual-tour:hover,
    .home-virtual-tour:active {
      align-items: center;
      background-color: #ffffff;
      border-radius: 2px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      color: ${Colors.primary.black.standard};
      display: flex;
      left: 10px;
      font-weight: normal;
      padding: 4px;
      position: absolute;
      text-decoration: none;
      text-transform: uppercase;
      top: 10px;

      svg {
        height: 20px;
        width: 20px;
      }
    }
  }
  .home-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    a,
    a:visited {
      color: ${Colors.primary.black.standard};
      text-decoration: none;

      &:hover,
      &:active {
        color: ${Colors.primary.claytonBlue.standard};
      }
    }
    .home-name {
      margin: 0;
      padding: 0;
    }
    .home-price {
      margin: 0;
      padding: 0;
    }
    .home-header-cta {
      display: none;
      margin-top: 10px;
      white-space: nowrap;
    }
  }

  .home-features {
    align-items: center;
    color: ${Colors.accent.grey1.standard};
    display: flex;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 17px;
    white-space: nowrap;

    svg {
      margin-right: 7px;
      height: 16px;
      width: 16px;
    }
    p:not(:last-child) {
      margin-right: 30px;
    }

    .caption {
      margin-bottom: 14px;
      margin-top: 14px;
    }
  }

  .home-details {
    padding: 10px;
    padding-bottom: 20px;
    position: relative;
  }
  .home-tags {
    padding-top: 10px;

    .label.large {
      color: ${Colors.primary.black.standard};
    }

    .home-tags-items {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;

      p,
      a {
        margin: 2px 0;
        text-decoration: none;
        width: 50%;
      }
      a {
        color: ${Colors.primary.claytonBlue.standard};
        font-family: 'source-sans-pro', sans-serif;
      }
    }
  }
  button {
    margin-top: 20px;
  }
  .stock-indicator,
  .unavailable-indicator {
    align-items: center;
    display: flex;
    text-transform: uppercase;

    &:before {
      background-color: ${Colors.accent.claytonGreen.standard};
      border-radius: 50%;
      content: 'nil';
      display: block;
      font-size: 0;
      height: 6px;
      margin-right: 4px;
      width: 6px;
    }
  }

  .unavailable-indicator {
    &:before {
      background-color: ${Colors.accent.ladyBug.standard};
    }
  }
  @media only screen and (min-width: ${variables.tablet_breakpoint}px) {
    .home-image {
      .home-image-container {
        height: 350px;
      }
    }
  }
  @media only screen and (min-width: ${variables.desktop_breakpoint}px) {
    &.horizontal {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .home-image {
        background-color: #ffffff;
        border-radius: 4px;
        padding: 20px;
        width: 45%;

        .home-image-container {
          max-height: 400px;
          width: 100%;
        }
      }
      .home-header {
        .home-header-cta {
          display: inline-block;
        }
      }
      .home-details {
        padding-left: 25px;
        padding-right: 25px;
        padding-top: 20px;
        width: 55%;

        .home-details-cta {
          display: none;
        }

        .home-header-cta {
          display: block;
        }
      }

      .stock-indicator,
      .unavailable-indicator {
        justify-content: flex-end;
      }

      .home-features {
        font-size: 16px;
        line-height: 27px;
        padding: 35px 0;

        svg {
          height: 20px;
          width: 20px;
        }

        p:not(:last-child) {
          border-right: 1px solid ${Colors.accent.grey5.standard};
          margin-right: 30px;
          padding: 5px 30px 5px 0px;
        }
      }

      .home-tags {
        border-top: 1px solid ${Colors.accent.grey5.standard};

        .heading {
          display: block;
          padding: 20px 0;
        }
        span {
          margin-bottom: 5px;
        }
      }
    }
    .home-tags {
      .home-tags-items {
        span,
        a {
          width: 33%;
        }
      }
    }
  }
`;
